import {useReducer} from "react";
import reducer from "./reducer";
import CategoryCampaignContext, {internalState} from "./context";
import {execute} from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import {ICategoryCampaign} from "../../models/category_campaign/response";
import {ICreateCategoryCampaign, IUpdateCategoryCampaign} from "../../models/category_campaign/request";
import {ICategoryCampaignQuery} from "../../models/category_campaign/query";
import moment from "moment/moment";

export interface IProps {
    children: React.ReactNode;
}

const CategoryCampaignContextProvider: React.FC<IProps> = (props) => {
    const [state, dispatch] = useReducer(reducer, internalState)

    const getData = async () => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });

                const { data } = await EndPoints.categoryCampaign.getAllCategoriesCampaigns(state.query);

                dispatch({ type: "SET_LIST", payload: { list: data } });
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });
            },
            throwException: false,
        });
    };

    const getDetails = async (id: number) => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "details" } });

                const { data } = await EndPoints.categoryCampaign.getCategoryCampaign(id);
                dispatch({ type: "SET_DETAILS", payload: { details: data } });
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "details" } });
            },
            throwException: false,
        });
    };

    const setDetails = async (data?: ICategoryCampaign) => {
        // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
    };

    const createCategoryCampaign = async (request: ICreateCategoryCampaign) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "create" },
                });

                await EndPoints.categoryCampaign.createCategoryCampaign(request);
                getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "create" },
                });
            },
            throwException: true,
        });
    };

    const updateCategoriesArrangementList = async (
        id: number,
        request: {
            "priority":number
        }
    ) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
                await EndPoints.categoryCampaign.updateCategoriesArrangementList(id, request);

                // getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
            },
            throwException: true,
        });
    };

    const updateCategoryCampaign = async (id: number, request: IUpdateCategoryCampaign) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
                await EndPoints.categoryCampaign.updateCategoryCampaign(id, request);

                getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
            },
            throwException: true,
        });
    };

    const deleteCategoryCampaign = async (id: number) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "delete" },
                });

                await EndPoints.categoryCampaign.deleteCategoryCampaign(id);

                getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "delete" },
                });
            },
            throwException: true,
        });
    };

    const setSearch = (search?: string) => {
        dispatch({ type: "SET_SEARCH", payload: { search } });
    };

    const setQuery = (query: ICategoryCampaignQuery) => {
        dispatch({ type: "SET_QUERY", payload: { query } });
    };

    const exportExcel = async (request: any) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "create" },
                });
                const data = await EndPoints.categoryCampaign.exportExcel(request, state.query);
                const url = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `Citys-${moment().format("yyyy-MM-d")}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "create" },
                });
            },
            throwException: true,
        });
    };

    return(
    <CategoryCampaignContext.Provider
    value={{
        ...state,
        actions: {
            getData,
            getDetails,
            setDetails,
            updateCategoriesArrangementList,

            createCategoryCampaign,
            updateCategoryCampaign,
            deleteCategoryCampaign,
            exportExcel,

            setSearch,
            setQuery,
        }
    }}
    >
        {props.children}
    </CategoryCampaignContext.Provider>
)
}

export default CategoryCampaignContextProvider;
